export default __webpack_public_path__ + "static/9-contact-us-mobile-ee147f121a47a725350d6859c920cf35.jpg";